import { connect } from 'react-redux'
import * as RX from 'reactxp';
import ButtonLink from '../../components/button_link';
import OutlineBox from '../../components/outline_box';
import * as ReactGA from '../../modules/google_analytics';
import t from '../../utils/i18n'
import { mapStateToProps } from '../../utils/mapper';
import { body, colors, h1, h2, h3 } from '../../utils/styles';

// tslint:disable:max-line-length
const styles = (multiplier) => ({
  bullet: RX.Styles.createViewStyle({
    backgroundColor: colors.black,
    borderRadius: 8 * multiplier,
    height: 8 * multiplier,
    marginRight: 8 * multiplier,
    top: 4 * multiplier,
    width: 8 * multiplier,
  }),
  header: RX.Styles.createTextStyle({
    color: colors.header,
    textAlign: 'left',
  }),
  info: RX.Styles.createViewStyle({
    flexDirection: 'row',
  }),
  wrapper: RX.Styles.createViewStyle({
    marginBottom: 8 * multiplier
  }),
});

const Bullet = ({ multiplier }) => <RX.View style={styles(multiplier).bullet} />;

const Info = ({ start, bold, end, last, width, phoneNumber, multiplier }:
  { start: string, bold: string, end: string, last?: boolean, width: number, phoneNumber: string, multiplier: number}) =>
  <RX.View style={[styles(multiplier).info, last ? { marginBottom: 0 } : { marginBottom: 8 * multiplier}]}>
    <Bullet { ... { multiplier }}/>
    <RX.Text style={[body(multiplier), {maxWidth: width - 16 * multiplier }]}>
      {start}<RX.Text style={{ fontWeight: 'bold'}}>{bold}</RX.Text>{end}
      <RX.Link
        style={{ textDecorationLine: 'underline', color: colors.primary }}
        url={`tel:${phoneNumber}`}>{phoneNumber}</RX.Link>.</RX.Text>
  </RX.View>;

const InfoButton = ({info, width, phoneNumber, multiplier}:
  {info: string, width: number, phoneNumber: string, multiplier: number}) =>
  <RX.View style={{marginLeft: 15}} >
    <RX.Text style={[h2(multiplier), { marginBottom: 7 * multiplier, marginTop: 30 * multiplier}]}>{info}</RX.Text>
    <RX.Link style={{
        backgroundColor: colors.secondary,
      borderRadius: 5 * multiplier,
        color: colors.white,
        fontSize: 16 * multiplier,
        fontWeight: 'bold',
        padding: 20 * multiplier,
        textAlign: 'center',
        textDecorationLine: 'none',
        width: 230 * multiplier,
        }}
      url={`tel:${phoneNumber}`}>Call {phoneNumber}</RX.Link>
  </RX.View>;

class Contact extends RX.Component<{ window: { width: number, multiplier: number }}, RX.CommonProps> {

  constructor(props: { window: { width: number, multiplier: number }}) {
    super(props);
  }

  public componentDidMount() {
    ReactGA.trackEvent(
      'Go to Contact',
      'Navigation',
    );
  }

  public render() {
    let { window: { width }} = this.props;
    const { window: { multiplier }} = this.props;
    width = width - 64 * multiplier;

    return (
      <RX.ScrollView >
        <RX.View style={styles(multiplier).wrapper}>
          <RX.Text style={[h1(multiplier), styles(multiplier).header, {marginTop: 20, marginBottom: 20}]}>{t('contact.headers.contact')}</RX.Text>
        </RX.View>
        <OutlineBox>
          <InfoButton info={t('contact.contactInfo.general.forInfo')}
          phoneNumber={t('contact.contactInfo.general.phone')}
            {...{ width, multiplier }}
           />
          <InfoButton info={t('contact.contactInfo.feedback.shareFeedback')}
            phoneNumber={t('contact.contactInfo.feedback.phone')}
            {...{ width, multiplier }}
          />
          <InfoButton info={t('contact.contactInfo.technical.forTech')}
            phoneNumber={t('contact.contactInfo.technical.phone')}
            {...{ width, multiplier }}
          />
          <InfoButton info={t('contact.contactInfo.switchboard.toReach')}
            phoneNumber={t('contact.contactInfo.switchboard.phone')}
            {...{ width, multiplier }}
          />
        </OutlineBox>
      </RX.ScrollView>
    );
  }
}

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/pages/contact/index.tsx